import antdSA from "antd/lib/locale/ar_EG"
import enMessages from "../locales/ar_SA.json"

const saLang = {
  messages: {
    ...enMessages
  },
  antd: antdSA,
  locale: "ar"
}

export default saLang

